<template>
  <div class="input-box__container" :class="{ borderless: borderless }">
    <v-tooltip
      open-delay=1000
      :left="tooltipLeft"
      :right="tooltipRight"
      :top="tooltipTop"
      :bottom="tooltipBottom"
      >
      <template v-slot:activator="{ on }">
        <span v-on="on" v-if="enableToolTip">
          <v-row no-gutters class="form-group" v-if="!noLabel">
            <span v-if="label !== ''" class="item-label">{{ label }}</span>
            <span v-else class="item-label" style="color:white" />
            <span v-if="![null, undefined, ''].includes(commentLabel)" class="item-comment-label">{{ commentLabel }}</span>
            <label class="form-group-label">
              <span v-if="required && !readonly" class="mandatory">必須</span>
            </label>
          </v-row>
          <component
            :is="inputComponent"
            v-if="hasFocus"
            v-bind="computedProps"
            v-on="computedListeners"
            label=""
            solo
            flat
            auto-grow
            rows="1"
            :solo-flat="borderless"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
          />
          <component
            v-else
            :is="inputComponent"
            v-bind="computedPropsForText"
            v-on="computedListeners"
            label=""
            solo
            flat
            auto-grow
            rows="1"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            type="text"
          />
        </span>
        <span v-else>
          <v-row no-gutters class="form-group" v-if="!noLabel">
            <span v-if="label !== ''" class="item-label">{{ label }}</span>
            <span v-else class="item-label" style="color:white" />
            <span v-if="![null, undefined, ''].includes(commentLabel)" class="item-comment-label">{{ commentLabel }}</span>
            <label class="form-group-label">
              <span v-if="required && !readonly" class="mandatory">必須</span>
            </label>
          </v-row>
          <component
            v-if="hasFocus"
            :is="inputComponent"
            v-bind="computedProps"
            v-on="computedListeners"
            label=""
            solo
            flat
            auto-grow
            rows="1"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
          />
          <component
            v-else
            :is="inputComponent"
            v-bind="computedPropsForText"
            v-on="computedListeners"
            label=""
            solo
            flat
            auto-grow
            rows="1"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            type="text"
          />
        </span>
      </template>
      <span v-html="tooltipText"></span>
    </v-tooltip>
  </div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import core from '@/rahmen/core'
import { VTextField, VTextarea } from 'vuetify/lib'

/**
 * @file DDv2用数値テキスト
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [integerDigit=String(Number.MAX_SAFE_INTEGER).length] - 整数部桁数指定
 * @vue-prop {Number} [minorDigit=0] - 少数部桁数指定
 * @vue-prop {Number} [max=Number.MAX_SAFE_INTEGER] - 許容最大値
 * @vue-prop {Number} [min=Number.MAX_SAFE_INTEGER * -1] - 許容最小値
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-numeric-box
    label="数値"
    v-model="numericValue"
    :required="true"
    :integerDigit="5"
    :minorDigit="2"
    />
 */
export default {
  name: 'DdNumericBox',
  extends: VTextField,
  components: {
    VTextarea
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 正数部桁数指定
     */
    integerDigit: {
      type: Number,
      default: String(Number.MAX_SAFE_INTEGER).length
    },
    /**
     * 小数部桁数指定
     */
    minorDigit: {
      type: Number,
      default: 0
    },
    /**
     * 入力可能最大値
     */
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    /**
     * 入力可能最小値
     */
    min: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER * -1
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 太枠
     */
    emphasis: {
      type: Boolean,
      default: false
    },
    /**
     * 枠線なし
     */
    borderless: {
      type: Boolean,
      default: false
    },
    /**
     * multiline が true のときは v-textarea を使う
     */
    multiline: {
      type: Boolean,
      default: false
    },
    /**
     * コメントラベル
     * ラベルの隣に小さい文字で配置
     */
    commentLabel: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    hasFocus: false,
    formatedText: '',
    isNegativeValue: false,
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
    this.formatedText = this.value
    this.innerValue = this.getSanitizedValue(this.value)
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    console.log('formatedText', this.formatedText)
  },
  watch: {
    /* readonly: function (n, o) {
      this.isReadonly = n
    }, */
    value: function (n, o) {
      this.innerValue = this.getSanitizedValue(n)
      this[controls.FORMAT_METHOD]()
    }
  },
  computed: {
    // どちらのコンポーネントを使うか返す computed
    inputComponent () {
      // multiline === true なら v-textarea、そうでなければ v-text-field
      return this.multiline ? 'v-textarea' : 'v-text-field'
    },
    inputTypeDetail () {
      return controls.getInputTypeDetail(controls.InputTypes.Numerical)
    },
    phtext () {
      if (!this.inputTypeDetail) {
        return ''
      } else {
        return !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.integerDigit) : ''
      }
    },
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        type: this.multiline ? 'text' : 'number',
        hideDetails: 'auto',
        dense: true,
        value: this.innerValue,
        class: this.$props.class + ' numeric-input' + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : '') + (this.emphasis ? ' emphasis-item' : ''),
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedPropsForText () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        type: 'text',
        hideDetails: 'auto',
        dense: true,
        value: this.formatedText,
        class: this.$props.class + ' numeric-input' + (this.isNegativeValue ? ' negative' : '') + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : '') + (this.emphasis ? ' emphasis-item' : ''),
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    /**
     * 入力値を処理し、数値に変換して親コンポーネントに通知します。
     * @param {*} value - v-text-fieldまたはv-textareaからの入力値
     */
    onInput (value) {
      let numericValue = null

      if (typeof value === 'number' && isFinite(value)) {
        numericValue = value
      } else if (typeof value === 'string') {
        const sanitized = value.replaceAll(',', '')

        // 入力途中の状態（空文字、ハイフン、末尾の小数点）を許容
        if (sanitized === '' || sanitized === '-' || (this.minorDigit > 0 && sanitized.endsWith('.'))) {
          numericValue = sanitized
        } else {
          const parsed = parseFloat(sanitized)
          if (!isNaN(parsed) && isFinite(parsed)) {
            numericValue = parsed
          } else {
            // 不正な入力は無視して表示を元に戻す
            this.$forceUpdate()
            return
          }
        }
      }

      this.innerValue = numericValue
      this.$emit('input', numericValue)
    },
    getSanitizedValue (inputVal) {
      if (typeof inputVal === 'string' && inputVal !== '') {
        var retVal = inputVal.replaceAll(',', '')
        if (isFinite(retVal)) {
          return parseFloat(retVal)
        } else {
          return ''
        }
      }
      return inputVal
    },
    onBlur: function (e) {
      console.log('onBlur', e, this.hasFocus)
      this.$set(this, 'hasFocus', false)
      console.log(this.computedPropsForText)
      console.log(this.hasFocus)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      } else {
        this.formatedText = this.innerValue
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      console.log('onFocus', e, this.hasFocus)
      this.$set(this, 'hasFocus', true)
      console.log(this.hasFocus)
      let val = '' + e.target.value
      val = val.replaceAll(',', '')
      e.target.value = val

      const elem = this.$el.querySelector('input, textarea')
      if (elem) {
        this.$nextTick(function () {
          elem.select()
        })
      }

      this.$emit('focus', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        intDigit: this.integerDigit,
        decimalDigit: this.minorDigit,
        max: this.max,
        min: this.min
      }
      console.log(target)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Numerical)

      if (!this.required && target.value === '') { return }
      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      console.log(controls.FORMAT_METHOD, this.innerValue)
      const val = String(this.innerValue)
      if ([undefined, null, 'undefined', 'null', '', '-'].includes(val)) {
        this.formatedText = ''
        return
      }
      const num = parseFloat(val) // parseFloatは末尾の'.'を無視する
      if (isNaN(num)) {
        this.formatedText = ''
        return
      }
      let formated = num.toLocaleString(undefined, { maximumFractionDigits: 20 })

      if (this.minorDigit !== 0) {
        console.log('1', formated)
        const dotPosition = formated.lastIndexOf('.')
        if (dotPosition === -1) {
          formated += `.${'0'.repeat(this.minorDigit)}`
        } else {
          const minorLen = formated.split('.')[1].length
          formated += '0'.repeat(this.minorDigit - minorLen)
        }
      }

      this.formatedText = formated
      this.isNegativeValue = core.isNegativeValue(val)
    }
  }
}
</script>
<style scoped>
.numeric-input ::v-deep input,
.numeric-input ::v-deep textarea {
  text-align: right;
}

.numeric-input.negative ::v-deep input,
.numeric-input.negative ::v-deep textarea {
  color: red;
}

</style>
